import { useTranslation } from 'react-i18next';

import { VFlex } from '@/package';
import { useTaskListContext } from '@/provider';

import { TaskList } from '../TaskList';

const TaskListWrapper = ({
  showTaskCreationDrawer,
}: {
  showTaskCreationDrawer: () => void;
}) => {
  const { selectedTaskIDList, taskList } = useTaskListContext();
  const { t } = useTranslation();

  return (
    <>
      <VFlex className="w-full items-center gap-2 pt-2">
        <VFlex className="items-center gap-2 text-body-xl text-gray-500">
          <span>{t('common.total.briming')}</span>
          <span>{taskList?.length || 0}</span>
        </VFlex>
        {!!selectedTaskIDList?.length && (
          <>
            <div className="h-4 w-px bg-gray-300" />
            <div className="font-bold text-gray-500">
              {selectedTaskIDList.length} Selected
            </div>
          </>
        )}
      </VFlex>
      <TaskList onCreateTask={() => showTaskCreationDrawer()} />
    </>
  );
};

export default TaskListWrapper;
